var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddCircle = function SvgAddCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8333 16.4993C29.8333 23.8631 23.8638 29.8327 16.5 29.8327C9.13616 29.8327 3.16663 23.8631 3.16663 16.4993C3.16663 9.13555 9.13616 3.16602 16.5 3.16602C23.8638 3.16602 29.8333 9.13555 29.8333 16.4993ZM16.5 10.166C17.0522 10.166 17.5 10.6137 17.5 11.166V15.4993H21.8333C22.3856 15.4993 22.8333 15.9471 22.8333 16.4993C22.8333 17.0516 22.3856 17.4993 21.8333 17.4993H17.5V21.8327C17.5 22.385 17.0522 22.8327 16.5 22.8327C15.9477 22.8327 15.5 22.385 15.5 21.8327V17.4993H11.1666C10.6143 17.4993 10.1666 17.0516 10.1666 16.4993C10.1666 15.9471 10.6143 15.4993 11.1666 15.4993H15.5V11.166C15.5 10.6137 15.9477 10.166 16.5 10.166Z",
    fill: "#3175F6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-circle.464ef749.svg";
export { ForwardRef as ReactComponent };